import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from 'components/Button/Button';
import Text from 'components/Fields/Text';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import { useFormatMessage } from 'components/IntlProvider';
import SurveyCreator from 'components/SurveyCreator';
import { Formik, Field, Form } from 'formik';
import styled from 'styled-components/macro';

const { Link } = RouterProvider;

const useStyles = makeStyles({
  content: {
    margin: '2rem',
  },
  btn: {
    margin: '0.5rem 0',
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
    },
  },
  btnDisabled: {
    color: 'red',
    margin: '0.5rem 0',
  },
  btnCancel: {
    margin: '0.5rem 0',
    backgroundColor: '#f50057',

    '&:hover': {
      backgroundColor: '#c51162',
    },
  },
  '@global': {
    '.sv_main .sv_custom_header': {
      zIndex: -1,
    },
  },
});

const FormWrapper = styled.div`
  margin: 2rem;
`;

const validate = (value: any) => {
  let error;
  if (!value) {
    error = 'Required';
  }
  return error;
};

const CreatorInstance = ({
  submitting,
  initialValues,
  backUrl,
  saveAndExit,
  saveTemplate,
  saveLocally,
  onSubmit,
  type,
}: any) => {
  const t = useFormatMessage();
  const classes = useStyles();
  const isNameProvided = initialValues && !!initialValues.name;
  const initialName = isNameProvided ? initialValues.name : '';

  return (
    <>
      <Formik
        initialValues={{ name: initialName }}
        onSubmit={onSubmit}
        enableReinitialize
      >
        <FormWrapper>
          <Form
            onChange={(event: any) => {
              saveLocally({ type, name: event.target.value });
            }}
          >
            <Grid container justify="space-between" alignItems="center">
              <Grid item xs={12} sm={6} md={3} lg={3}>
                <Field name="name" validate={validate} required>
                  {({ field, meta }: { field: any; meta: any }) => {
                    return (
                      <Text
                        label={t(
                          'dashboard.template.labels.name',
                          'Template name'
                        )}
                        meta={meta}
                        input={field}
                        fullWidth
                        variant="outlined"
                      />
                    );
                  }}
                </Field>
              </Grid>
              <Grid item xs={12} sm={3} md={3} lg={2} xl={1}>
                <Field name="saveExit">
                  {({
                    form,
                  }: {
                    form: { isValid: boolean; dirty: boolean; values: any };
                  }) => {
                    return (
                      <Button
                        isLoading={submitting}
                        variant="contained"
                        fullWidth
                        disabled={!isNameProvided && !form.values.name}
                        color="primary"
                        onClick={() => {
                          saveAndExit({
                            values: form.values,
                            withRedirect: true,
                          });
                        }}
                        className={classes.btn}
                      >
                        {t('dashboard.template.btn.saveExit', 'Save and Exit')}
                      </Button>
                    );
                  }}
                </Field>
                <Field name="save">
                  {({
                    form,
                  }: {
                    form: { isValid: boolean; dirty: boolean; values: any };
                  }) => {
                    return (
                      <Button
                        isLoading={submitting}
                        variant="contained"
                        fullWidth
                        disabled={!isNameProvided && !form.values.name}
                        color="primary"
                        onClick={() =>
                          saveTemplate({
                            values: form.values,
                            withRedirect: true,
                          })
                        }
                        className={classes.btn}
                      >
                        {t('dashboard.template.btn.save', 'Save template')}
                      </Button>
                    );
                  }}
                </Field>
                <Link to={backUrl}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() => localStorage.removeItem(type)}
                    color="secondary"
                    className={classes.btnCancel}
                  >
                    {t('dashboard.template.btn.cancel', 'Cancel')}
                  </Button>
                </Link>
              </Grid>
            </Grid>
          </Form>
        </FormWrapper>
      </Formik>

      <SurveyCreator initialValues={initialValues} templateData={{ type }} />
    </>
  );
};

export default CreatorInstance;
